export const addDirectorSchema = {
  fullName: {
    presence: { allowEmpty: false },
  },
  nationality: {
    presence: { allowEmpty: false },
  },
  phone: {
    presence: { allowEmpty: false },
  },
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
  designation: {
    presence: { allowEmpty: false },
  },
  educationQualification: {
    presence: { allowEmpty: false },
  },
};

export const addShareholderSchema = {
  fullName: {
    presence: { allowEmpty: false },
  },
  nationality: {
    presence: { allowEmpty: false },
  },
  phone: {
    presence: { allowEmpty: false },
  },
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
  occupation: {
    presence: { allowEmpty: false },
  },
  shareholdingPercentage: {
    presence: { allowEmpty: false },
  },
};

export const addRiskSchema = {
  risk: {
    presence: { allowEmpty: false },
  },
  mitigationMeasure: {
    presence: { allowEmpty: false },
  },
};

export const companyDetailsSchema = {
  companyName: {
    presence: { allowEmpty: false },
  },
  incorporationNumber: {
    presence: { allowEmpty: false },
  },
  contactPerson: {
    presence: { allowEmpty: false },
  },
  contactEmail: {
    presence: { allowEmpty: false },
    email: true,
  },
  contactPhone: {
    presence: { allowEmpty: false },
    length: { minimum: 8 },
  },
  postalAddress: {
    presence: { allowEmpty: false },
    length: { minimum: 5 },
  },
  physicalAddress: {
    presence: { allowEmpty: false },
  },
};

export const solutionDetailsSchema = {
  problemDescription: {
    presence: { allowEmpty: false },
    length: { minimum: 20 },
  },
  solutionDescription: {
    presence: { allowEmpty: false },
    length: { minimum: 20 },
  },
  legalChallenges: {
    presence: { allowEmpty: false },
    length: { minimum: 5 },
  },
  specialExemptions: {
    presence: { allowEmpty: false },
    length: { minimum: 5 },
  },
};

export const solutionSummarySchema = {
  solutionName: {
    presence: { allowEmpty: false },
  },
  natureOfOperation: {
    presence: { allowEmpty: false },
  },
  scaleOfOperation: {
    presence: { allowEmpty: false },
  },
  solutionAttribute: {
    presence: { allowEmpty: false },
  },
  solutionObjectives: {
    presence: { allowEmpty: false },
  },
  marketOfOperation: {
    presence: { allowEmpty: false },
  },
  sourceOfFunds: {
    presence: { allowEmpty: false },
  },
  technologiesUsed: {
    presence: { allowEmpty: false },
  },
  testingPeriod: {
    presence: { allowEmpty: false },
  },
  deploymentDuration: {
    presence: { allowEmpty: false },
  },
};
